"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var expressionOfInterestSummaryStyles = core_1.makeStyles(function (_a) {
    var typography = _a.typography, palette = _a.palette;
    return ({
        item: {
            fontSize: typography.fontSM,
            color: palette.text.secondary,
        },
    });
}, { name: 'GqlCheckout_ExpressionOfInterestSummary' });
exports.default = expressionOfInterestSummaryStyles;
